import script from "./SearchView.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchView.vue?vue&type=script&setup=true&lang=js"

import "./SearchView.vue?vue&type=style&index=0&id=818fa89a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-818fa89a"]])

export default __exports__